// extracted by mini-css-extract-plugin
module.exports = {"lessonToast":"frontend-common-styles-LessonToast__lessonToast--2Cba1"};